import { jsx as r, jsxs as s } from "react/jsx-runtime";
import e from "styled-components";
import n from "../../../../utils/colors.js";
import d from "./Item.js";
const l = e.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`, m = e.div`
  border: 1px solid ${n.blueGrey50};
`, g = () => {
  const o = [];
  return /* @__PURE__ */ r(l, { children: o.map((t, i) => /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ r(d, { item: t }),
    i < o.length - 1 && /* @__PURE__ */ r(m, {})
  ] }, t.id)) });
};
export {
  g as default
};
